/**
 * Created by ZhangJunPeng on 2017/5/23.
 */

import React from 'react';
import DayTimeDiv from './DayTimeDiv';
import MeetingDiv4Day from './MeetingDiv4Day';
import RightClickMenu from './RightClickMenu';
import PropTypes from 'prop-types';

class DayTimeTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      mouseDown: false,
      startKey: -1,
      list: []
    };
    this.makeTimeTable = this.makeTimeTable.bind(this);
    this.mouseDown = this.mouseDown.bind(this);
    this.enter = this.enter.bind(this);
  }

  componentWillReceiveProps() {
    this.setState({ mouseDown: false, startKey: -1, list: [] });
  }

  makeTimeTable() {
    const { days, timeMap, handleByClickDay, room } = this.props;
    let timeTable = new Array(days);
    for (let i = 0; i < days; i++) {
      timeTable.push(
        <DayTimeDiv
          {...this.props}
          time={timeMap.get(i)}
          handleByClickDay={handleByClickDay}
          mouseDown={this.mouseDown}
          enter={this.enter}
          selected={this.state.list}
          key={`${room.id}${timeMap.get(i).valueOf()}`}
        />
      );
    }
    return timeTable;
  }

  mouseDown(key) {
    this.setState({ mouseDown: true, startKey: key, list: [key] });
  }

  enter(key) {
    const { mouseDown, startKey } = this.state;
    if (!mouseDown) return;
    const list = [startKey];
    const isRight = Number(key) > Number(startKey);
    const isLeft = Number(key) < Number(startKey);
    // 根据拖动的位置计算被选中的对象数组
    for (let i = 1; i <= 47; i++) {
      if (isRight) {
        if (
          Number(`${i}0`) > Number(startKey) &&
          Number(key) >= Number(`${i}0`)
        ) {
          list.push(`${i}0`);
        }
        if (
          Number(`${i}1`) > Number(startKey) &&
          Number(key) >= Number(`${i}1`)
        ) {
          list.push(`${i}1`);
        }
      }
      if (isLeft) {
        if (
          Number(`${i}0`) < Number(startKey) &&
          Number(key) <= Number(`${i}0`)
        ) {
          list.push(`${i}0`);
        }
        if (
          Number(`${i}1`) < Number(startKey) &&
          Number(key) <= Number(`${i}1`)
        ) {
          list.push(`${i}1`);
        }
      }
    }
    this.setState({ list });
  }

  makeMeetingDiv(meetings, id) {
    let meetingsDiv = new Array();
    let continuousDay = false;
    meetings.forEach((v, i, arr) => {
      if (i !== 0 && v.startTime === arr[i - 1].endTime) {
        continuousDay = !continuousDay;
      } else {
        continuousDay = false;
      }
      meetingsDiv.push(
        <div key={v.id}>
          <MeetingDiv4Day
            roomId={id}
            {...this.props}
            meeting={v}
            continuousDay={continuousDay}
          />
          <RightClickMenu roomId={id} {...this.props} meeting={v} />
        </div>
      );
    });
    return meetingsDiv;
  }

  render() {
    const { room } = this.props;
    return (
      <ul className="table-right-div table-right-div-td ul3">
        {this.makeMeetingDiv(room.meetings, room.id)}
        {this.makeTimeTable()}
      </ul>
    );
  }
}

DayTimeTable.propTypes = {
  index: PropTypes.number.isRequired,
  room: PropTypes.object.isRequired,
  days: PropTypes.number.isRequired,
  timeMap: PropTypes.object.isRequired,
  handleByClickDay: PropTypes.func.isRequired
};

export default DayTimeTable;



// WEBPACK FOOTER //
// ./src/components/meeting/DayTimeTable.js